import React from 'react'

import FormManager from "../../../gd-form/common/form-manager"
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import FormError from "../../../gd-form/common/form-error/form-error"
import FieldFormElement from "../../../fields3/render/form-elemnent"

type Props = {
    form: FormManager
}

export default function CustomFieldDisplayName(props: Props) {

    const field = _.clone(gd.fields.customFields.displayName)
    field.placeholder = props.form.getValue('name')

    return (
        <FormRowFlex  field={field}>
            <div className="flex-column-left-top">
                <FieldFormElement className = "w-300"
                                  field     = {field}
                                  form      = {props.form}/>
                <FormError form = {props.form}
                           name = {field.fieldId} />
            </div>
        </FormRowFlex>
    )
}